import React, { useEffect, useState, useRef } from 'react';
import { EyeIcon, EyeOffIcon, LockIcon } from 'lucide-react';
export function LoginForm() {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [holdProgress, setHoldProgress] = useState(0);
  const [showTip, setShowTip] = useState(false);
  const holdStartRef = useRef<number | null>(null);
  const animationFrameRef = useRef<number | null>(null);
  const HOLD_DURATION = 2500; // 2.5 seconds

  const setPreviewCookie = () => {
    // Root-domain cookie so cctherock.org can read it
    document.cookie = 'cz_preview=1; Max-Age=7200; Path=/; Domain=.cctherock.org; Secure; SameSite=Lax';
    // Fallback host-only cookie if some browsers reject Domain=
    if (!document.cookie.includes('cz_preview=1')) {
      document.cookie = 'cz_preview=1; Max-Age=7200; Path=/; Secure; SameSite=Lax';
    }
  };
  const redirectToRootWithToken = () => {
    const url = new URL('https://cctherock.org/');
    url.searchParams.set('cz_preview', '1');
    window.location.replace(url.toString()); // avoids back-button loop
  };
  const handleLoginSuccess = () => {
    console.log('Login successful!');
    window.dispatchEvent(new CustomEvent('loginSuccess'));

    // 1s celebration pulse (optional)
    const stage = document.getElementById('cz-stage');
    if (stage) {
      stage.classList.add('success');
      setTimeout(() => stage.classList.remove('success'), 1000);
    }

    // Grant preview + go to root with helper QS
    setPreviewCookie();
    setTimeout(() => {
      redirectToRootWithToken();
    }, 2000);
  };
  const handleLoginFailure = () => {
    setError('Incorrect password. Please try again.');
    window.dispatchEvent(new CustomEvent('loginFailure'));
    setTimeout(() => {
      setHoldProgress(0);
      window.dispatchEvent(new CustomEvent('holdProgress', {
        detail: {
          progress: 0
        }
      }));
    }, 1000);
  };
  const startHold = () => {
    setError('');
    holdStartRef.current = Date.now();
    const updateProgress = () => {
      if (holdStartRef.current === null) return;
      const elapsed = Date.now() - holdStartRef.current;
      const progress = Math.min(elapsed / HOLD_DURATION * 100, 100);
      setHoldProgress(progress);
      window.dispatchEvent(new CustomEvent('holdProgress', {
        detail: {
          progress
        }
      }));
      if (progress < 100) {
        animationFrameRef.current = requestAnimationFrame(updateProgress);
      } else {
        if (password !== 'Joe123!') handleLoginFailure();else handleLoginSuccess();
      }
    };
    animationFrameRef.current = requestAnimationFrame(updateProgress);
  };
  const cancelHold = () => {
    if (animationFrameRef.current !== null) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }
    holdStartRef.current = null;
    setHoldProgress(0);
    window.dispatchEvent(new CustomEvent('holdProgress', {
      detail: {
        progress: 0
      }
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };
  useEffect(() => {
    return () => {
      if (animationFrameRef.current !== null) cancelAnimationFrame(animationFrameRef.current);
    };
  }, []);
  useEffect(() => {
    if (!showTip) return;
    const hideTip = () => setShowTip(false);
    const handleKeyDown = (e: KeyboardEvent) => {
      hideTip();
    };
    const handleMouseDown = (e: MouseEvent) => {
      hideTip();
    };
    const handleTouchStart = (e: TouchEvent) => {
      hideTip();
    };
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('touchstart', handleTouchStart);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('touchstart', handleTouchStart);
    };
  }, [showTip]);
  return <div className="w-full max-w-md mx-auto px-6" id="outer-words-display" data-id="element-9">
      <h1 className="text-base sm:text-lg font-light text-white mb-2" data-id="element-10">
        Welcome to...
        <br data-id="element-11" />
        <span className="text-lg sm:text-xl md:text-2xl font-bold" data-id="element-12">
          Your <span className="shine" data-id="element-13">NEW</span> ClientCzar Website!
        </span>
      </h1>

      <p className="text-xs sm:text-xs text-gray-400 mb-8" data-id="element-14">
        Sign in to view live preview.
      </p>

      <form onSubmit={handleSubmit} onKeyDown={e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        setShowTip(true);
      }
    }} data-id="element-15">
        <div className="mb-6 px-8 -mx-8" data-id="element-16">
          <div className="flex items-center justify-between mb-2" data-id="element-17">
            <label htmlFor="password" className="text-white text-sm font-medium" data-id="element-18">
              Password <span className="text-red-500" data-id="element-19">*</span>
            </label>
            {error && <p className="text-red-400 text-xs" data-id="element-20">{error}</p>}
          </div>

          <div id="poda" data-id="element-21">
            <div className="glow" data-id="element-22"></div>
            <div className="darkBorderBg" data-id="element-23"></div>
            <div className="darkBorderBg" data-id="element-24"></div>
            <div className="darkBorderBg" data-id="element-25"></div>
            <div className="white" data-id="element-26"></div>
            <div className="border" data-id="element-27"></div>

            <div id="main" data-id="element-28">
              <input id="password" placeholder="Enter your password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
              setPassword(e.target.value);
              setError('');
            }} className="input" required autoComplete="current-password" data-id="element-29" />

              <div id="input-mask" data-id="element-30"></div>
              <div id="pink-mask" data-id="element-31"></div>
              <div className="filterBorder" data-id="element-32"></div>

              <div id="filter-icon" onClick={() => setShowPassword(s => !s)} data-id="element-33">
                {showPassword ? <EyeOffIcon size={20} className="text-gray-400" data-id="element-34" /> : <EyeIcon size={20} className="text-gray-400" data-id="element-35" />}
              </div>

              <div id="search-icon" data-id="element-36">
                <LockIcon size={20} className="text-gray-400" data-id="element-37" />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-38">
          <div className="tooltip-container" data-show={showTip ? '1' : '0'} data-id="element-39">
            <span className="tooltip" data-id="element-40">Click and hold me to sign in</span>

            <button type="button" className="glow-button" onMouseDown={e => {
            setShowTip(false);
            startHold();
          }} onMouseUp={cancelHold} onMouseLeave={cancelHold} onTouchStart={e => {
            setShowTip(false);
            startHold();
          }} onTouchEnd={cancelHold} onTouchCancel={cancelHold} data-id="element-41">
              <div className="button-progress" style={{
              width: `${holdProgress}%`
            }} data-id="element-42" />
              <span className="button-text-main" data-id="element-43">Sign in →</span>
              <span className="button-text-extra" data-id="element-44">(Hold until verified)</span>
            </button>
          </div>
        </div>

        <div className="text-center mt-4" data-id="element-45">
          <a href="#" className="text-blue-400 hover:text-blue-300 text-sm" data-id="element-46">
            Forgot password?
          </a>
        </div>
      </form>

      <p className="mt-6 text-center text-xs text-white/50" data-id="element-47">
        CONFIDENTIAL INFORMATION
        <br data-id="element-48" />© {new Date().getFullYear()}{' '}
        <a href="https://clientczar.com" target="_blank" rel="noopener" className="underline decoration-white/30 hover:decoration-white/70" data-id="element-49">
          ClientCzar
        </a>
        . All rights reserved.
      </p>
    </div>;
}